import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Découverte du projet",
    text: "Échange direct avec Marius, fondateur de WebUP. Un seul interlocuteur, du brief à la mise en ligne.",
    perks: ["Rendez-vous en visioconférence", "ou en face à face selon votre préférence"],
  },
  { n: "02", title: "Maquette sous 48h", text: "Premier aperçu visuel concret. Vous voyez immédiatement la direction." },
  { n: "03", title: "Développement", text: "Code propre, performances soignées, accessibilité respectée." },
  { n: "04", title: "Optimisation SEO", text: "Balisage, vitesse, schema.org : conçu pour Google dès le premier jour." },
  { n: "05", title: "Mise en ligne", text: "Nom de domaine, HTTPS et tests finaux. Tout est prêt le jour J." },
  { n: "06", title: "Suivi & évolution", text: "Maintenance, analyses et améliorations continues." },
];

export const Process = () => (
  <section id="processus" data-testid="process-section" className="py-24 md:py-32 bg-paper">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="mb-20 max-w-3xl">
        <p className="font-mono-label text-ink/60"><span className="rule" />Méthodologie</p>
        <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl text-ink tracking-tight leading-[1.05]">
          Un processus clair, <em className="italic font-light">de l’idée à la mise en ligne</em>.
        </h2>
      </div>

      <ol className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/10 border border-ink/10">
        {steps.map((s, i) => (
          <motion.li
            key={s.n}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-30px" }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.06 }}
            className="bg-white p-8 md:p-10 group hover:bg-paper-soft transition-colors min-h-[240px] flex flex-col"
            data-testid={`process-step-${i}`}
          >
            <div className="flex items-baseline justify-between">
              <span className="font-display text-5xl text-ink/15 group-hover:text-ink/30 transition-colors">{s.n}</span>
              <span className="h-px w-12 bg-ink/20" aria-hidden />
            </div>
            <h3 className="mt-8 font-display text-2xl text-ink">{s.title}</h3>
            <p className="mt-3 text-sm text-ink/65 leading-relaxed">{s.text}</p>
            {s.perks && (
              <ul className="mt-4 space-y-1.5 text-xs text-ink/70 pt-3 border-t border-ink/10">
                {s.perks.map((p) => (
                  <li key={p} className="flex items-start gap-1.5">
                    <span className="text-cyan-600 font-bold">✓</span>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            )}
          </motion.li>
        ))}
      </ol>
    </div>
  </section>
);
